import React, { useEffect, useState } from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Card } from "../../CommonElements/Hajj/Card";
import { Container, Label, Spinner } from "reactstrap";
import { Button, Stack } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { HugeiconsIcon } from "@hugeicons/react";
import { Mail01Icon } from "@hugeicons/core-free-icons";
import { AntInput } from "../../CommonElements/AntInput";
import { Form } from "reactstrap";
import { useChangeEmailMutation } from "../../services/profile/profile";
import { Otp } from "./Otp";

export const ChangeEmail = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [initialSeconds, setInitialSeconds] = useState(0);

  useEffect(() => {
    const changeEmailTo = localStorage.getItem("changeEmailTo");
    const changeEmailExpireAt = localStorage.getItem("changeEmailExpireAt");
    const checkChangeEmail = () => {
      if (
        changeEmailTo &&
        changeEmailExpireAt &&
        new Date(changeEmailExpireAt) < new Date()
      ) {
        localStorage.removeItem("changeEmailTo");
        localStorage.removeItem("changeEmailExpireAt");
        return true;
      }

      return false;
    };

    if (checkChangeEmail()) {
      return;
    }

    if (changeEmailTo && changeEmailExpireAt) {
      setEmail(changeEmailTo);
      setInitialSeconds(
        Math.floor((new Date(changeEmailExpireAt) - new Date()) / 1000)
      );
    }

    return checkChangeEmail;
  }, [email]);

  const updateExpiresAt = (expiresAt) => {
    setInitialSeconds(600); // 10 minutes = 600 seconds
  };

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const { mutate: changeEmailMutation, isPending } =
    useChangeEmailMutation(setError);

  const onSubmit = (data) => {
    changeEmailMutation(data, {
      onSuccess: (response) => {
        setEmail(data.email);
        updateExpiresAt();
      },
    });
  };

  return (
    <Stack gap={5}>
      <PageHeader title={t("CHANGE_EMAIL")}   />

      <Container fluid>
        {!!email ? (
          <Otp
            {...{ updateExpiresAt, email, changeEmailMutation, initialSeconds }}
          />
        ) : (
          <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
            <Card
              className="pattern-card mx-auto"
              style={{ maxWidth: "36.3125rem" }}
            >
              <p className="H2">{t("CHANGE_EMAIL")}</p>
              <p className="h5 text-secondary fw-bold mb-4">
                {t("CHANGE_EMAIL_DESCRIPTION")}
              </p>

              <Stack gap={2} className="mb-4">
                <Label for="email" className="required">
                  {t("EMAIL")}
                </Label>
                <Controller
                  control={control}
                  name="email"
                  rules={{
                    required: t("EMAIL_REQUIRED"),
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: t("EMAIL_INVALID"),
                    },
                  }}
                  render={({ field }) => (
                    <AntInput
                      id="email"
                      type="email"
                      placeholder={t("EMAIL")}
                      {...field}
                      prefix={<HugeiconsIcon size={20} icon={Mail01Icon} />}
                    />
                  )}
                />
                {errors.email && (
                  <div className="text-danger small mt-1">
                    {errors.email.message}
                  </div>
                )}
              </Stack>

              <Button
                disabled={isPending}
                type="submit"
                variant="primary"
                className="w-100"
              >
                {isPending ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    {t("SEND_CODEIN_PROGRESS")}
                  </>
                ) : (
                  t("SEND_CODE")
                )}
              </Button>
            </Card>
          </Form>
        )}
      </Container>
    </Stack>
  );
};
